export default function CsMoneyMakingThreats() {
  return (
    <h2>Cs Money Making Threats</h2>
  );
}
